import { render, staticRenderFns } from "./StudentTransfer.vue?vue&type=template&id=02e467e8&scoped=true&"
import script from "./StudentTransfer.vue?vue&type=script&lang=js&"
export * from "./StudentTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e467e8",
  null
  
)

export default component.exports